import React, { SVGProps } from 'react';

const DownArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="13"
    height="9"
    viewBox="0 0 13 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.84116 0L12.9058 9H0.776574L6.84116 0Z"
      fill={props.fill || '#00BDA5'}
    />
  </svg>
);

export default DownArrow;
